/**
 *  @author     Arif Setianto <arifsetiantoo@gmail.com>
 *  @created    18/06/2018
 */
import { ImageUploaderComponent } from '@shared/module/uploader/image-uploader.component';
import { CommonModule } from '@angular/common';
import { ButtonModule } from '@progress/kendo-angular-buttons';
import { NgModule } from '@angular/core';
import { FileUploaderComponent } from '@shared/module/uploader/file-uploader.component';
import { DocUploaderComponent } from '@shared/module/uploader/doc-uploader.component';

@NgModule({
    imports: [CommonModule, ButtonModule],
    declarations: [ImageUploaderComponent, FileUploaderComponent, DocUploaderComponent],
    exports: [ImageUploaderComponent, FileUploaderComponent, DocUploaderComponent],
})
export class UploaderModule {}



// WEBPACK FOOTER //
// ./src/shared/module/uploader/uploader.module.ts